import React, { useState } from "react";
import { toast } from "react-toastify";
import useNotifications from "../../Hooks/useNotifications";
import PvPChallengeReceivedModal from "../Modals/PvPChallengeReceivedModal";

const NotificationHandler = () => {
  const [challengeModal, setChallengeModal] = useState(null);

  const handleNotificationEvent = (event) => {
    try {
      const data = JSON.parse(event.data);
      
      switch (data.type) {
        case "pvp_challenge":
          handlePvPChallenge(data);
          break;
        case "pvp_battle":
          handlePvPBattle(data);
          break;
        default:
          // Handle other notification types or just trigger refetch
          break;
      }
    } catch (error) {
      console.error("Error parsing notification:", error);
    }
  };

  const handlePvPChallenge = (data) => {
    if (data.action === "received") {
      // Show challenge received modal
      setChallengeModal(data.challenge);
    } else if (data.action === "accepted") {
      toast.success(`${data.opponent} accepted your battle challenge!`, {
        position: "top-center",
        autoClose: 4000
      });
    } else if (data.action === "declined") {
      toast.info(`${data.opponent} declined your battle challenge.`, {
        position: "top-center",
        autoClose: 4000
      });
    }
  };

  const handlePvPBattle = (data) => {
    if (data.action === "opponent_forfeited") {
      toast.success(`${data.opponent} forfeited the battle. You win!`, {
        position: "top-center",
        autoClose: 5000
      });
    }
  };

  const handleChallengeAccept = (response) => {
    toast.success("Challenge accepted! Redirecting to battle...", {
      position: "top-center",
      autoClose: 3000
    });
    
    // Redirect to battle
    if (response.battle_id) {
      window.location.href = `/pvp-battle/${response.battle_id}`;
    }
  };

  const handleChallengeDecline = () => {
    toast.info("Challenge declined.", {
      position: "top-center",
      autoClose: 2000
    });
  };

  useNotifications({
    onEvent: handleNotificationEvent
  });

  return (
    <>
      {challengeModal && (
        <PvPChallengeReceivedModal
          challenge={challengeModal}
          onClose={() => setChallengeModal(null)}
          onAccept={handleChallengeAccept}
          onDecline={handleChallengeDecline}
        />
      )}
    </>
  );
};

export default NotificationHandler;
